import { Link } from 'react-router-dom';
import { usePageSEO } from '../components/SEO';

const NotFound = () => {
  usePageSEO({
    title: 'Pagina non trovata (404) | Rete Italia',
    description: 'La pagina che cerchi non esiste o è stata spostata.',
    noindex: true,
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 pt-24 pb-16 flex items-center justify-center">
      <div className="text-center px-4">
        <h1 className="text-6xl md:text-7xl font-bold text-[#009246] mb-4">404</h1>
        <p className="text-xl text-gray-700 mb-6 max-w-md mx-auto">
          Pagina non trovata. La pagina che cerchi non esiste o è stata spostata.
        </p>
        <Link
          to="/"
          className="inline-block bg-[#009246] hover:bg-[#007a3d] text-white px-6 py-3 rounded-lg font-semibold transition-colors"
        >
          Torna alla Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
